import * as React from 'react';

import * as styles from './SwitchLabel.css';

interface ISwitchLabelProps {
  text: string;
}

export const SwitchLabel: React.VFC<ISwitchLabelProps> = ({ text }) => (
  <span className={styles['container']}>{text}</span>
);
